import { useQuasar } from 'quasar'

export const useQuasarIcons = () => {
  const quasar = useQuasar()

  quasar.iconMapFn = (iconName) => {
    const cls = iconName.startsWith('tmi-') ? `tmi ${iconName}` : `mdi-r mdi-${iconName}`
    return { cls }
  }
}
